import { Phase } from './env';
import { SupportedLanguage } from './language';

export const SUBSCRIBE_MAIL: Record<
  Phase,
  {
    links: Record<SupportedLanguage, string>;
    api: Record<SupportedLanguage, string>;
  }
> = {
  dev: {
    links: {
      ko: 'https://go.3billion.io/newsletter-signup-ko',
      en: 'https://go.3billion.io/newsletter-signup-en',
    },
    api: {
      ko: 'https://go.3billion.io/l/1084872/2025-11-27/bl7816',
      en: 'https://go.3billion.io/l/1084872/2025-11-27/bl7813',
    },
  },
  prod: {
    links: {
      ko: 'https://go.3billion.io/newsletter-signup-ko',
      en: 'https://go.3billion.io/newsletter-signup-en',
    },
    api: {
      ko: 'https://go.3billion.io/l/1084872/2025-11-25/bl6y4l',
      en: 'https://go.3billion.io/l/1084872/2025-11-25/bl6y4h',
    },
  },
};
